import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { apiClient, provisioningPath } from '@/lib/api-client';
import type { RunPlaybookBody, RunPlaybookResponse } from '@/types/provisioning';

interface RunPlaybookVariables {
  playbookId: number;
  body: RunPlaybookBody;
}

/**
 * POST /api/admin/provisioning/playbooks/:id/run — triggers a playbook run.
 *
 * Returns `{ task_id }`. The caller is responsible for opening the task
 * drawer / status panel and polling via `useProvisioningTask`.
 */
export function useRunPlaybook(): UseMutationResult<
  RunPlaybookResponse,
  Error,
  RunPlaybookVariables
> {
  return useMutation({
    mutationFn: ({ playbookId, body }) =>
      apiClient.post<RunPlaybookResponse>(
        provisioningPath(`/playbooks/${playbookId}/run`),
        body,
      ),
  });
}
